import React, { Component } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import logo from './DubberMSTeamsSmall_New.png';
import infoicon from './InfoIcon.png';
import cross from './RedCross.png';
import questionMark from './BlueQuestionMark.png';
import tick from './TransparentTick.png';
import axios from 'axios';
import { Ring } from './Ring';

class ChatConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consentConfirmed: false,
      loading: false,
      errorMessage: '',
      consentChecked: false,
    };

    this.confirmConsent = this.confirmConsent.bind(this);
  }

  confirmConsent(event) {
    this.setState({ loading: true });
    event.preventDefault();
    let config = {
      headers: { Authorization: 'Jwt ' + this.props.accessToken },
    };
    let body = {
      portal: this.props.portal,
      slug: this.props.slug,
      tenantId: this.props.tenantId,
      type: 'chat',
    };
    this.setState({
      errorMessage: '',
    });
    axios
      .post(this.props.confirmChatConsentUrl, body, config)
      .then(taskResponse => {
        this.setState({
          loading: false,
          consentConfirmed: taskResponse.data.chatConsentConfirmed,
          consentChecked: true,
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error.data);
        console.log(error);
        this.setState({ errorMessage: error.data, consentChecked: true });
      });
  }

  render() {
    var consentLink =
      'https://login.microsoftonline.com/' +
      this.props.tenantId +
      '/adminconsent?client_id=' +
      this.props.consentAppId;
    var consentTick = this.state.consentConfirmed ? (
      <img className="green-tick" src={tick} alt="" />
    ) : (
      <img className="green-tick" src={cross} alt="" />
    );
    if (!this.state.consentChecked) {
      consentTick = <img className="green-tick" src={questionMark} alt="" />;
    }
    return (
      <div>
        <div className="ui center aligned container head">
          <div className="stepheader">
            <div className="step">Step 1</div>
            <img src={logo} alt="Dubber MS Teams" className="small-logo" />
            <div className="step-back">
              <NavLink tag={Link} to="/">
                &lt; Back
              </NavLink>
            </div>
          </div>
          <div className="ui aligned container start">
            <div className="step-header">
              <h3>Consent Permissions for chat recording</h3>
            </div>
            <div className="instructions">
              <img src={infoicon} alt="i" />
              <br />
              <p>
                <b>
                  You must consent permissions for Dubber application to capture chat from teams
                  users and integration.
                </b>
              </p>
              <br />
              <p>
                The links will open in a new tab and the credentials used to consent the permissions
                must have the role Global Admin
              </p>
            </div>
            <div className="column-half">
              <div className="space20px">&nbsp;</div>
              <div className="space20px">
                <h4>Step 1</h4>
                <a href={consentLink} className="download" target="botA" rel="noopener noreferrer">
                  Consent permissions for chat recording
                </a>
                {consentTick}
              </div>
            </div>
            <label id="errorMessageLabel" className="errorText">
              {this.state.errorMessage}
            </label>
          </div>
          <div className={!this.state.consentConfirmed ? 'link' : 'hidden-wizard-step'}>
            <button onClick={this.confirmConsent} className="next-link">
              Confirm
            </button>
          </div>
          <div className={this.state.consentConfirmed ? 'link' : 'hidden-wizard-step'}>
            <div>
              <NavLink tag={Link} to="/chatsettings">
                Next
              </NavLink>
            </div>
          </div>
          <Ring loading={this.state.loading} />
        </div>
      </div>
    );
  }
}

export { ChatConsent };
